export const mixrConstants = {
  GET_USERS_REQUEST: 'MIXR/GET_USERS_REQUEST',
  GET_USERS_SUCCESS: 'MIXR/GET_USERS_SUCCESS',
  GET_USERS_FAILURE: 'MIXR/GET_USERS_FAILURE',

  GET_MEDIA_REQUEST: 'MIXR/GET_MEDIA_REQUEST',
  GET_MEDIA_SUCCESS: 'MIXR/GET_MEDIA_SUCCESS',
  GET_MEDIA_FAILURE: 'MIXR/GET_MEDIA_FAILURE',

  GET_MIXR_DETAIL_REQUEST: 'MIXR/GET_MIXR_DETAIL_REQUEST',
  GET_MIXR_DETAIL_SUCCESS: 'MIXR/GET_MIXR_DETAIL_SUCCESS',
  GET_MIXR_DETAIL_FAILURE: 'MIXR/GET_MIXR_DETAIL_FAILURE',

  DELETE_FILE_REQUEST: 'MIXR/DELETE_FILE_REQUEST',
  DELETE_FILE_SUCCESS: 'MIXR/DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE: 'MIXR/DELETE_FILE_FAILURE',

  ATTEND_MIXR_REQUEST: 'MIXR/ATTEND_MIXR_REQUEST',
  ATTEND_MIXR_SUCCESS: 'MIXR/ATTEND_MIXR_SUCCESS',
  ATTEND_MIXR_FAILURE: 'MIXR/ATTEND_MIXR_FAILURE',

  UPDATE_RSVP_DATA: 'MIXR/UPDATE_RSVP_DATA',

  ADD_STAFF_ROLE_REQUEST: 'MIXR/ADD_STAFF_ROLE_REQUEST',
  ADD_STAFF_ROLE_SUCCESS: 'MIXR/ADD_STAFF_ROLE_SUCCESS',
  ADD_STAFF_ROLE_FAILURE: 'MIXR/ADD_STAFF_ROLE_FAILURE',

  REMOVE_STAFF_ROLE_REQUEST: 'MIXR/REMOVE_STAFF_ROLE_REQUEST',
  REMOVE_STAFF_ROLE_SUCCESS: 'MIXR/REMOVE_STAFF_ROLE_SUCCESS',
  REMOVE_STAFF_ROLE_FAILURE: 'MIXR/REMOVE_STAFF_ROLE_FAILURE',

  // TRANSFER_ORGANIZER_ROLE_REQUEST: 'MIXR/TRANSFER_ORGANIZER_ROLE_REQUEST',
  // TRANSFER_ORGANIZER_ROLE_SUCCESS: 'MIXR/TRANSFER_ORGANIZER_ROLE_SUCCESS',
  // TRANSFER_ORGANIZER_ROLE_FAILURE: 'MIXR/TRANSFER_ORGANIZER_ROLE_FAILURE',

  CANCEL_MIXR_REQUEST: 'MIXR/CANCEL_MIXR_REQUEST',
  CANCEL_MIXR_SUCCESS: 'MIXR/CANCEL_MIXR_SUCCESS',
  CANCEL_MIXR_FAILURE: 'MIXR/CANCEL_MIXR_FAILURE',

  SET_ATTENDING_TYPE: 'MIXR/SET_ATTENDING_TYPE',

  JOIN_GROUP_REQUEST: 'MIXR/JOIN_GROUP_REQUEST',
  JOIN_GROUP_SUCCESS: 'MIXR/JOIN_GROUP_SUCCESS',
  JOIN_GROUP_FAILURE: 'MIXR/JOIN_GROUP_FAILURE',

  SET_MIXR_ROLE: 'MIXR/SET_MIXR_ROLE',

  SET_PREVIEW_MIXR_DATA: 'MIXR/SET_PREVIEW_MIXR_DATA',

  CREATE_MIXR_REQUEST: 'MIXR/CREATE_MIXR_REQUEST',
  CREATE_MIXR_SUCCESS: 'MIXR/CREATE_MIXR_SUCCESS',
  CREATE_MIXR_FAILURE: 'MIXR/CREATE_MIXR_FAILURE',

  EDIT_MIXR_REQUEST: 'MIXR/EDIT_MIXR_REQUEST',
  EDIT_MIXR_SUCCESS: 'MIXR/EDIT_MIXR_SUCCESS',
  EDIT_MIXR_FAILURE: 'MIXR/EDIT_MIXR_FAILURE',

  GET_FEE_CATEGORIES_REQUEST: 'MIXR/GET_FEE_CATEGORIES_REQUEST',
  GET_FEE_CATEGORIES_SUCCESS: 'MIXR/GET_FEE_CATEGORIES_SUCCESS',
  GET_FEE_CATEGORIES_FAILURE: 'MIXR/GET_FEE_CATEGORIES_FAILURE',

  GET_RECUR_END_DATE_REQUEST: 'MIXR/GET_RECUR_END_DATE_REQUEST',
  GET_RECUR_END_DATE_SUCCESS: 'MIXR/GET_RECUR_END_DATE_SUCCESS',
  GET_RECUR_END_DATE_FAILURE: 'MIXR/GET_RECUR_END_DATE_FAILURE',

  CLEAR_RECUR_END_DATE_ERROR: 'MIXR/CLEAR_RECUR_END_DATE_ERROR',

  CLEAR_CREATED_MIXR_VALUES: 'MIXR/CLEAR_CREATED_MIXR_VALUES',

  SET_INVITE_INFO: 'MIXR/SET_INVITE_INFO',
  RESET_EDIT_SUCCESS_FLAG: 'MIXR/RESET_EDIT_SUCCESS_FLAG',

  SET_PREVIEW_DATA_TO_EDIT: 'MIXR/SET_PREVIEW_DATA_TO_EDIT',

  SET_MIXR_DATA_BY_KEY: 'MIXR/SET_MIXR_DATA_BY_KEY',

  SET_INITIAL_STATE: 'MIXR/SET_INITIAL_STATE',

  SAVE_DRAFT_REQUEST: 'MIXR/SAVE_DRAFT_REQUEST',
  SAVE_DRAFT_SUCCESS: 'MIXR/SAVE_DRAFT_SUCCESS',
  SAVE_DRAFT_FAILURE: 'MIXR/SAVE_DRAFT_FAILURE',
  RESET_SAVE_DRAFT: 'MIXR/RESET_SAVE_DRAFT',
  RESET_SAVE_DRAFT_ERROR: 'MIXR/RESET_SAVE_DRAFT_ERROR',
  GET_DRAFTS_REQUEST: 'MIXR/GET_DRAFTS_REQUEST',
  GET_DRAFTS_SUCCESS: 'MIXR/GET_DRAFTS_SUCCESS',
  GET_DRAFTS_FAILURE: 'MIXR/GET_DRAFTS_FAILURE',

  GET_DRAFT_DATA_REQUEST: 'MIXR/GET_DRAFT_DATA_REQUEST',
  GET_DRAFT_DATA_SUCCESS: 'MIXR/GET_DRAFT_DATA_SUCCESS',
  GET_DRAFT_DATA_FAILURE: 'MIXR/GET_DRAFT_DATA_FAILURE',

  DELETE_DRAFT_REQUEST: 'MIXR/DELETE_DRAFT_REQUEST',
  DELETE_DRAFT_SUCCESS: 'MIXR/DELETE_DRAFT_SUCCESS',
  DELETE_DRAFT_FAILURE: 'MIXR/DELETE_DRAFT_FAILURE',

  GET_EXISTING_MIXRS_REQUEST: 'MIXR/GET_EXISTING_MIXRS_REQUEST',
  GET_EXISTING_MIXRS_SUCCESS: 'MIXR/GET_EXISTING_MIXRS_SUCCESS',
  GET_EXISTING_MIXRS_FAILURE: 'MIXR/GET_EXISTING_MIXRS_FAILURE',

  SET_PREVIEW_FROM_MODAL_FLAG: 'MIXR/SET_PREVIEW_FROM_MODAL_FLAG',

  GET_USERS_TO_INVITE_REQUEST: 'MIXR/GET_USERS_TO_INVITE_REQUEST',
  GET_USERS_TO_INVITE_SUCCESS: 'MIXR/GET_USERS_TO_INVITE_SUCCESS',
  GET_USERS_TO_INVITE_FAILURE: 'MIXR/GET_USERS_TO_INVITE_FAILURE',

  SHOW_ADVANCE_SETTING: 'MIXR/SHOW_ADVANCE_SETTING',

  SEND_INVITES_REQUEST: 'MIXR/SEND_INVITES_REQUEST',
  SEND_INVITES_SUCCESS: 'MIXR/SEND_INVITES_SUCCESS',
  SEND_INVITES_FAILURE: 'MIXR/SEND_INVITES_FAILURE',

  UPDATE_MIXR_RATING_REQUEST: 'MIXR/UPDATE_MIXR_RATING_REQUEST',
  UPDATE_MIXR_RATING_SUCCESS: 'MIXR/UPDATE_MIXR_RATING_SUCCESS',
  UPDATE_MIXR_RATING_FAILURE: 'MIXR/UPDATE_MIXR_RATING_FAILURE',

  GET_MORE_REVIEWS_REQUEST: 'MIXR/GET_MORE_REVIEWS_REQUEST',
  GET_MORE_REVIEWS_SUCCESS: 'MIXR/GET_MORE_REVIEWS_SUCCESS',
  GET_MORE_REVIEWS_FAILURE: 'MIXR/GET_MORE_REVIEWS_FAILURE'
}
